<template>
  <div>
    <header>
      <HeaderWhite/>
    </header>
    <main>
      <ProfileContents/>
    </main>
    <footer>
    </footer>
  </div>
</template>

<script>
import HeaderWhite from '../components/common/HeaderWhite.vue'
import ProfileContents from '../components/profile/ProfileContents.vue'

export default {
  name: 'profile',
  components: {
    HeaderWhite,
    ProfileContents
  }
}
</script>